/** Allowed journal tag colors (must match backend TAG_COLORS). */
export const JOURNAL_TAG_COLORS = [
  '#EF4444',
  '#F97316',
  '#EAB308',
  '#22C55E',
  '#14B8A6',
  '#3B82F6',
  '#8B5CF6',
  '#EC4899',
  '#6B7280',
  '#78716C',
] as const;

export type JournalTagColor = (typeof JOURNAL_TAG_COLORS)[number];
